import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { Label, Text, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";
import { StartStockCountFormValues } from "../../types";

export interface NameFormInputProps {}

export const NameFormInput = ({}: NameFormInputProps) => {
  const { t } = useTranslation("stock_counts");
  const { control } = useFormContext<StartStockCountFormValues>();
  return (
    <View>
      <Label label={t("form.count_name.label")} required></Label>
      <Text>{t("form.count_name.description")}</Text>
      <Controller
        name="name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.count_name.placeholder")}
            filled={false}
          />
        )}
      />
    </View>
  );
};
